/* file description */
import { Button, Divider, Tabs } from 'antd';
import * as React from 'react';
import { useEffect, useState, useRef, useMemo, useCallback } from 'react';
import TabPage from './TabPage';
import styles from './index.module.less';
import { SPTabListPropsType, TabItemType } from './type';
import _ from 'lodash';
import useValuesStore from '@/store/useValuesStore';
import useMetaStore from '@/store/useMetaStore';
import { PlusOutlined } from '@ant-design/icons';
import RuleController from '@/components/RuleController';
import { AbilityPoint } from '@/const';

export const SPTabList: React.FC<SPTabListPropsType> = (props) => {
  const {
    schema,
    refList,
  } = props;
  const [activeKey, setActiveKey] = useState('');
  const { values, setValues } = useValuesStore();
  const { pageType, pageConfig } = useMetaStore((state) => state);
  const value = values[schema.code] || [];


  useEffect(() => {
    if (!activeKey && value && value.length > 0) {
      setActiveKey(_.toString(value[0]._id));
    }
  }, [value]);

  const onTabChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const onChange = (v) => {
    setValues(schema.code, v);
  };

  const add = () => {
    const id = _.uniqueId();
    onChange([...value, {
      _id: id,
    }]);
    setActiveKey(id);
  };

  const remove = (targetKey: string) => {
    const newValue = value.filter((x) => x._id !== targetKey);
    onChange && onChange(newValue);
    const activeValue = newValue.find((x) => x._id === targetKey);
    if (!activeValue) {
      setActiveKey(newValue[0]?._id);
    }
  };

  const onEdit = (targetKey: string, action: 'add' | 'remove') => {
    // 删除事件不透传
    if (action === 'add') {
      add();
    } else {
      remove(targetKey);
    }
  };


  const createTabName = useCallback(({ val, index }: { val: Record<string, any>; index: number }) => {
    const moduleConfig = pageConfig.pageModuleConfig?.[schema.code];
    const name = moduleConfig?.tabName || '';
    const resultArr = name.match(/\$\{.+?\}/g);
    if (!resultArr) {
      return `Tab ${index + 1}`;
    }

    const fieldName = resultArr?.[0]?.slice(2, -1);
    return val?.[fieldName] || `Tab ${index + 1}`;
  }, [pageConfig.pageModuleConfig, schema]);

  return (
    <>
      <Divider />
      {
        pageType !== 'view' && (
          <RuleController data={{ [schema.code]: value }} id={`${schema.code}.add-btns`}>
            <Button
              type="primary"
              ghost
              onClick={add}
              className={styles.buttonTabAdd}
            >
              {pageConfig?.pageModuleConfig?.[schema.code]?.addButtonText || '新建'}
            </Button>
          </RuleController>
        )
      }
      <Tabs
        hideAdd
        onChange={onTabChange}
        activeKey={activeKey}
        onEdit={onEdit}
        type="editable-card"
      >
        {
          value.map((tab, index) => {
            return (
              <Tabs.TabPane
                tab={createTabName({ val: tab, index })}
                key={tab._id}
                forceRender
                className={styles.tabContainerCard}
                closable={pageType !== 'view'}
              >
                <RuleController
                  moduleCode={pageType === 'view' ? schema.code : undefined}
                  ability={pageType === 'view' ? AbilityPoint.canView : undefined}
                  displayUnauthorizedInfo
                >
                  <TabPage
                    value={tab}
                    rowId={tab._id}
                    schema={props.schema}
                    refList={refList}
                  />
                </RuleController>
              </Tabs.TabPane>
            );
          })
        }
      </Tabs>
    </>
  );
};
SPTabList.displayName = 'SPTabList';

